'use client';

import React from 'react';
import { LinkProps, ListItem, ListItemButton, ListItemText, SxProps } from '@mui/material';
import { Link as NavigableLink } from '../../components/Link';

export type MobileNavMenuItemProps = Omit<LinkProps, 'component' | 'alignItems' | 'ref'>;

const sx: SxProps = {
  width: '100%',
  px: 2,
  py: 1,
};

export const MobileNavMenuItem = ({
  children,
  ref,
  href,
  ...props
}: MobileNavMenuItemProps & { ref?: React.Ref<HTMLAnchorElement> }) => {
  if (!href) {
    return (
      <ListItem>
        <ListItemButton sx={sx}>
          <ListItemText>{children}</ListItemText>
        </ListItemButton>
      </ListItem>
    );
  }

  return (
    <ListItem>
      <ListItemButton
        component={NavigableLink}
        ref={ref}
        href={href}
        target={props.type === 'EXTERNAL' ? '_blank' : undefined}
        prefetch={false}
        sx={sx}
        {...props}
      >
        <ListItemText>{children}</ListItemText>
      </ListItemButton>
    </ListItem>
  );
};
